// ========== 悬浮可拖拽缩放控制 ==========
export class ZoomControl {
    constructor() {
        this.MIN_SCALE = 0.90;
        this.MAX_SCALE = 1.10;
        this.STEP = 0.02;
        this.STORAGE_KEY = 'birchcloud_zoom_scale';
        this.POS_KEY = 'birchcloud_zoom_pos';
        
        this.currentScale = 1;
        this.isDragging = false;
        this.dragX = 0;
        this.dragY = 0;
        this.dragXPercent = 0;
        this.dragYPercent = 0;
        
        // 记录初始视口宽度（用于检测浏览器缩放）
        this.baseInnerWidth = window.innerWidth;
        this.baseOuterWidth = window.outerWidth;
        
        this.initElements();
        if (!this.isValid()) return;
        
        this.init();
    }
    
    initElements() {
        this.zoomEl = document.getElementById('zoomFloating');
        this.decBtn = document.getElementById('zfDecBtn');
        this.incBtn = document.getElementById('zfIncBtn');
        this.display = document.getElementById('zfDisplay');
        this.resetBtn = document.getElementById('zfResetBtn');
        this.dragHandle = document.getElementById('zfDragHandle');
        this.wrap = document.getElementById('zoom-wrap');
        this.outer = document.getElementById('zoom-outer');
    }
    
    isValid() {
        return this.zoomEl && this.decBtn && this.incBtn && 
               this.display && this.resetBtn && this.wrap && this.outer;
    }
    
    init() {
        this.setupResizeObserver();
        this.bindEvents();
        this.restorePosition();
        this.restoreScale();
        this.setupZoomDetection();
    }
    
    setupResizeObserver() {
        if (window.ResizeObserver) {
            const ro = new ResizeObserver(() => {
                this.syncOuterHeight();
                window.dispatchEvent(new CustomEvent('zoomwrap:resize'));
            });
            ro.observe(this.wrap);
        }
    }
    
    syncOuterHeight() {
        if (!this.wrap || !this.outer) return;
        const logicalHeight = this.wrap.scrollHeight;
        const visualHeight = logicalHeight * this.currentScale;
        this.outer.style.height = visualHeight + 'px';
    }
    
    applyScale(scale) {
        scale = Math.round(scale * 100) / 100;
        scale = Math.max(this.MIN_SCALE, Math.min(this.MAX_SCALE, scale));
        this.currentScale = scale;
        
        requestAnimationFrame(() => {
            document.documentElement.style.setProperty('--zoom-scale', scale);
            
            const hero = document.querySelector('.hero');
            if (hero) {
                const viewportHeight = window.innerHeight;
                const viewportWidth = window.innerWidth;
                const aspectRatio = viewportWidth / viewportHeight;
                const isPortrait = aspectRatio < 1.5;
                
                let baseHeight;
                if (isPortrait) {
                    if (viewportWidth < 768) {
                        baseHeight = Math.max(viewportHeight, 500);
                    } else if (viewportWidth < 1024) {
                        baseHeight = Math.max(viewportHeight, 600);
                    } else {
                        baseHeight = Math.max(viewportHeight, 615);
                    }
                } else {
                    baseHeight = viewportWidth / 2.33;
                    baseHeight = Math.max(baseHeight, 400);
                }
                
                let adjustedHeight = baseHeight / scale;
                adjustedHeight = Math.max(400, Math.min(2000, adjustedHeight));
                
                hero.style.height = adjustedHeight + 'px';
                document.documentElement.style.setProperty('--hero-actual-height', adjustedHeight + 'px');
            }
            
            this.syncOuterHeight();
            
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('zoomwrap:resize'));
            }, 50);
        });
        
        this.decBtn.disabled = scale <= this.MIN_SCALE;
        this.incBtn.disabled = scale >= this.MAX_SCALE;
        this.display.textContent = Math.round(scale * 100) + '%';
        
        try {
            localStorage.setItem(this.STORAGE_KEY, scale.toString());
        } catch(e) {}
    }
    
    resetScale() {
        this.applyScale(1);
        try {
            localStorage.removeItem(this.STORAGE_KEY);
        } catch(e) {}
    }
    
    restoreScale() {
        let scale = 1;
        try {
            const saved = localStorage.getItem(this.STORAGE_KEY);
            if (saved) {
                const parsed = parseFloat(saved);
                if (!isNaN(parsed) && parsed >= this.MIN_SCALE && parsed <= this.MAX_SCALE) {
                    scale = parsed;
                }
            }
        } catch(e) {}
        this.applyScale(scale);
    }
    
    bindEvents() {
        this.decBtn.addEventListener('click', () => {
            const current = parseFloat(this.display.textContent) / 100;
            this.applyScale(current - this.STEP);
        });
        
        this.incBtn.addEventListener('click', () => {
            const current = parseFloat(this.display.textContent) / 100;
            this.applyScale(current + this.STEP);
        });
        
        this.resetBtn.addEventListener('click', () => this.resetScale());
        
        this.setupDragEvents();
        
        window.addEventListener('resize', () => {
            this.updatePositionOnResize();
            this.applyScale(this.currentScale);
        });
    }
    
    setupZoomDetection() {
        let resizeTimer;
        
        const handleResize = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.updatePositionOnResize();
                this.compensateBrowserZoom();
            }, 50);
        };
        
        // 监听所有可能触发的事件
        window.addEventListener('resize', handleResize);
        
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', handleResize);
            window.visualViewport.addEventListener('scroll', handleResize);
        }
        
        // 使用 MutationObserver 监听 style 变化（某些浏览器缩放会改变 style）
        const observer = new MutationObserver(handleResize);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['style']
        });
        
        // 初始化
        this.compensateBrowserZoom();
    }
    
    compensateBrowserZoom() {
        // 最简单可靠的方法：直接读取浏览器缩放级别
        // 通过比较 screen.width 和 window.innerWidth
        const screenWidth = window.screen.width;
        const innerWidth = window.innerWidth;
        const outerWidth = window.outerWidth;
        
        // 计算缩放比例
        // 注意：这个方法在不同浏览器可能有差异
        let zoomLevel = 1;
        
        // 方法：使用 window.devicePixelRatio
        if (window.devicePixelRatio) {
            zoomLevel = window.devicePixelRatio;
        }
        
        // 应用反向缩放（缩放级别越大，我们的 scale 越小）
        const scale = 1 / zoomLevel;
        this.zoomEl.style.transform = `scale(${scale})`;
        this.zoomEl.style.transformOrigin = 'center center';
        
        console.log(`Zoom compensation: devicePixelRatio=${zoomLevel}, scale=${scale}`);
    }
    
    updatePositionOnResize() {
        const savedPos = this.getPosition();
        if (savedPos && !this.isDragging) {
            // 从百分比重新计算像素位置
            const x = (savedPos.xPercent / 100) * window.innerWidth;
            const y = (savedPos.yPercent / 100) * window.innerHeight;
            
            // 直接使用百分比设置，避免重复计算
            const maxXPercent = ((window.innerWidth - this.zoomEl.offsetWidth) / window.innerWidth) * 100;
            const maxYPercent = ((window.innerHeight - this.zoomEl.offsetHeight) / window.innerHeight) * 100;
            
            this.dragXPercent = Math.max(0.4, Math.min(maxXPercent, savedPos.xPercent));
            this.dragYPercent = Math.max(0.4, Math.min(maxYPercent, savedPos.yPercent));
            
            this.zoomEl.style.left = this.dragXPercent + '%';
            this.zoomEl.style.top = this.dragYPercent + '%';
        }
    }
    
    setupDragEvents() {
        this.dragHandle.addEventListener('mousedown', (e) => this.startDrag(e.clientX, e.clientY, e));
        this.dragHandle.addEventListener('touchstart', (e) => {
            const touch = e.touches[0];
            this.startDrag(touch.clientX, touch.clientY, e);
        }, { passive: false });
        
        document.addEventListener('mousemove', (e) => this.onDrag(e.clientX, e.clientY));
        document.addEventListener('touchmove', (e) => {
            if (this.isDragging) {
                const touch = e.touches[0];
                this.onDrag(touch.clientX, touch.clientY);
            }
        }, { passive: false });
        
        document.addEventListener('mouseup', () => this.endDrag());
        document.addEventListener('touchend', () => this.endDrag());
    }
    
    startDrag(clientX, clientY, event) {
        this.isDragging = true;
        this.dragStartX = clientX;
        this.dragStartY = clientY;
        this.originX = this.zoomEl.offsetLeft;
        this.originY = this.zoomEl.offsetTop;
        this.zoomEl.style.cursor = 'grabbing';
        event.preventDefault();
        event.stopPropagation();
    }
    
    onDrag(clientX, clientY) {
        if (!this.isDragging) return;
        const dx = clientX - this.dragStartX;
        const dy = clientY - this.dragStartY;
        this.setPosition(this.originX + dx, this.originY + dy);
    }
    
    endDrag() {
        if (this.isDragging) {
            this.isDragging = false;
            this.zoomEl.style.cursor = 'grab';
            this.savePosition();
        }
    }
    
    getPosition() {
        try {
            const saved = localStorage.getItem(this.POS_KEY);
            if (saved) {
                const pos = JSON.parse(saved);
                // 支持旧版本的像素值和新版本的百分比值
                if (pos && typeof pos.xPercent === 'number' && typeof pos.yPercent === 'number') {
                    return pos;
                } else if (pos && typeof pos.x === 'number' && typeof pos.y === 'number') {
                    // 将旧的像素值转换为百分比（迁移逻辑）
                    return {
                        xPercent: (pos.x / window.innerWidth) * 100,
                        yPercent: (pos.y / window.innerHeight) * 100
                    };
                }
            }
        } catch(e) {}
        return null;
    }
    
    setPosition(x, y) {
        const maxX = window.innerWidth - this.zoomEl.offsetWidth;
        const maxY = window.innerHeight - this.zoomEl.offsetHeight;
        const clampedX = Math.max(4, Math.min(maxX, x));
        const clampedY = Math.max(4, Math.min(maxY, y));
        
        // 计算百分比位置
        this.dragXPercent = (clampedX / window.innerWidth) * 100;
        this.dragYPercent = (clampedY / window.innerHeight) * 100;
        
        // 使用百分比设置位置，而不是像素
        this.zoomEl.style.left = this.dragXPercent + '%';
        this.zoomEl.style.top = this.dragYPercent + '%';
        this.zoomEl.style.right = 'auto';
        this.zoomEl.style.bottom = 'auto';
        
        this.dragX = clampedX;
        this.dragY = clampedY;
    }
    
    savePosition() {
        try {
            // 保存百分比位置而不是像素位置
            localStorage.setItem(this.POS_KEY, JSON.stringify({ 
                xPercent: this.dragXPercent, 
                yPercent: this.dragYPercent 
            }));
        } catch(e) {}
    }
    
    restorePosition() {
        const savedPos = this.getPosition();
        if (savedPos) {
            // 从百分比转换为当前视口的像素位置
            const x = (savedPos.xPercent / 100) * window.innerWidth;
            const y = (savedPos.yPercent / 100) * window.innerHeight;
            this.setPosition(x, y);
        }
    }
}

export function initFloatingZoom() {
    new ZoomControl();
}
